// extracted by mini-css-extract-plugin
export default {"LevelScore":"sAVAw","LevelScore__block":"VcXx3","LevelScore_default":"RnjHy"};